import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Tile from '../../components/Tile';
import { FaCalendarAlt, FaClock, FaNotesMedical, FaGraduationCap, FaUmbrellaBeach, FaMoneyBillWave } from 'react-icons/fa';

const tiles = [
  {
    title: 'Wynagrodzenia',
    description: 'Szablony rozmów o wynagrodzeniach, podwyżkach i zasadach wypłaty.',
    icon: <FaMoneyBillWave />,    
    to: '/communication/salary',
  },
  {
    title: 'Praca w sobotę',
    description: 'Szablony rozmów dotyczących pracy w weekendy i odmowy pracy w sobotę.',
    icon: <FaCalendarAlt />,
    to: '/communication/saturday-work',
    gradient: 'pink',
  },
  {
    title: 'Praca w nadgodzinach',
    description: 'Gotowe wzory rozmów o nadgodzinach i ich rozliczeniu z pracodawcą.',
    icon: <FaClock />,
    gradient: 'purple',
    to: '/communication/overtime',
  },
  {
    title: 'L4',
    description: 'Szablony rozmów przy zgłaszaniu zwolnienia lekarskiego i kontakcie z pracodawcą.',
    icon: <FaNotesMedical />,    
    to: '/communication/sick-leave',
    gradient: 'green',
  },
  {
    title: 'Praca a szkoła',
    description: 'Wzory rozmów o urlopach szkoleniowych i dostosowaniu grafiku do nauki.',
    icon: <FaGraduationCap />,
    
    to: '/communication/work-and-school',
  },
  {
    title: 'Wakacje i ferie',
    description: 'Szablony rozmów o planowaniu urlopu i składaniu wniosków urlopowych.',
    icon: <FaUmbrellaBeach />,
    gradient: 'pink',
    to: '/communication/vacation',
  },
];



const Communication = () => {
  const navigate = useNavigate();
  const handleTileClick = (to) => {
    navigate(to);
  };


  return (
    <Container className="py-4">
      <h1 className="mb-4 fw-bold text-center">Komunikacja</h1>
      <Row className="g-4 justify-content-center">
        {tiles.map((tile) => (
          <Col key={tile.title} xs={12} sm={6} md={4}>
            <Tile {...tile} onClick={() => handleTileClick(tile.to)} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Communication;